
export default {
    FETCH_MATERIAL_DECK_DATA: "material-deck/FETCH_MATERIAL_DECK_DATA",
    FETCH_MATERIAL_DECK_DATA_SUCCESS: "material-deck/FETCH_MATERIAL_DECK_DATA_SUCCESS",
    FETCH_MATERIAL_DECK_DATA_FAIL: "material-deck/FETCH_MATERIAL_DECK_DATA_FAIL",

    SET_LOADER: "material-deck/SET_LOADER",

    DECK_TIMESTAMP_GENERATION: "material-deck/DECK_TIMESTAMP_GENERATION",
    DECK_TIMESTAMP_GENERATION_SUCCESS: "material-deck/DECK_TIMESTAMP_GENERATION_SUCCESS",
    DECK_TIMESTAMP_GENERATION_FAIL: "material-deck/DECK_TIMESTAMP_GENERATION_FAIL",

    DECK_LOG: "material-deck/DECK_LOG",
    DECK_LOG_SUCCESS: "material-deck/DECK_LOG_SUCCESS",
    DECK_LOG_FAIL: "material-deck/DECK_LOG_FAIL",

    UPDATE_MATERIAL_DECK_URL: "material-deck/UPDATE_MATERIAL_DECK_URL",
    UPDATE_MATERIAL_DECK_URL_SUCCESS: "material-deck/UPDATE_MATERIAL_DECK_URL_SUCCESS",
    UPDATE_MATERIAL_DECK_URL_FAIL: "material-deck/UPDATE_MATERIAL_DECK_URL_FAIL",

    LEAD_DECK_IMAGES_CHECK: "material-deck/LEAD_DECK_IMAGES_CHECK",
    LEAD_DECK_IMAGES_CHECK_SUCCESS: "material-deck/LEAD_DECK_IMAGES_CHECK_SUCCESS",
    GET_SCREENSHOTS: "material-deck/GET_SCREENSHOTS",
    GET_SCREENSHOTS_SUCCESS: "material-deck/GET_SCREENSHOTS_SUCCESS",
    GET_SCREENSHOTS_FAIL: "material-deck/GET_SCREENSHOTS_FAIL",
}